import React from 'react';
import { cn } from 'utils';

const FormLayoutGroup: React.FC<{
  children: React.ReactNode;
  columns?: number;
  mdColumns?: number;
}> = ({ children, columns = 1, mdColumns = 2 }) => {
  return (
    <div
      className={cn(
        'grid',
        `grid-cols-${columns}`,
        `md:grid-cols-${mdColumns}`,
        mdColumns > 1 ? 'gap-4' : ''
      )}
    >
      {children}
    </div>
  );
};

export default FormLayoutGroup;
